const CurvedProgressBar = ({ usedSize, totalSize, strokeWidth=20, radius=100, color }) => {
    let usedS = usedSize.split(" ");
    let totalSpace = totalSize.split(" ");
    const progress = (usedS[0] / totalSpace[0]) * 100;

    const circumference = 2 * Math.PI * radius;

    const progressOffset = circumference * (1 - (45 + (progress / (100 / 45))) / 100)

    console.log(progressOffset)

    return (
        <svg width={radius * 2} height={radius}>
            <circle
                stroke="#dfe8ed"
                fill="none"
                strokeWidth={strokeWidth}
                cx={radius}
                cy={radius}
                r={radius - strokeWidth / 2}
            />

            <circle
                stroke={color}
                fill="none"
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={progressOffset}
                cx={radius}
                cy={radius}
                r={radius - strokeWidth / 2}
                transform={`rotate( ${radius} ${radius})`}
            />

            <text
                x="50%"
                y="60%"
                textAnchor="middle"
                dy=".3em"
                fontSize="1em"
                style={{
                    fontSize: '29px',
                    fontWeight: 1000,
                }}
                fill={color}
            >
                {usedSize}
            </text>

            <text
                x="50%"
                y="96%"
                textAnchor="middle"
                dy=".3em"
                fontSize="1em"
                fill='#c0c9cf'
            >
                 {`of ${totalSize}`}
            </text>
        </svg>
    );
};

export default CurvedProgressBar;
